import { applyMiddleware, createStore } from 'redux';
import { getPersistConfig } from 'redux-deep-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducers';

const persistConfig = getPersistConfig({
  key: 'root',
  storage: storage,
  whitelist: ['routing.selectedZone'],
  rootReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
let store;

export function configureStore() {
  if (process.env.NODE_ENV === 'development') {
    store = createStore(
      persistedReducer,
      composeWithDevTools({ trace: true, traceLimit: 50 })(
        applyMiddleware(thunk),
      ),
    );
  } else {
    store = createStore(persistedReducer, applyMiddleware(thunk));
  }

  return {
    store,
    persistor: persistStore(store),
  };
}

/** @returns {import('redux').Store} */
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return store;
};
